import { prompt } from "./../Control/Vue/Notifications/Prompts";
import { HandlerType } from "./base/HandlerType";
import { postUrlEncoded } from "./LegacyAxiosUtil";

export class NewspaperAdSaveButton implements HandlerType {
	protected readonly saveAdButton: JQuery;
	protected readonly saveAdUrl: string;
	protected readonly isDraft: boolean;
	private loading = false;

	constructor(private button: JQuery) {
		this.saveAdButton = this.button;
		this.saveAdButton.on("click", (event) => void this.onButtonClick(event));
		this.saveAdUrl = button.data("url");
		this.isDraft = button.data("is-draft");
	}

	private async onButtonClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading) {
			return;
		}

		this.loading = true;
		const data = {
			attachedItemId: jQuery("#attachedItemSelector").val(),
			body: jQuery(".mia-adBody > textarea").val(),
			heading: jQuery(".mia-adHeading > textarea").val(),
		};

		try {
			const response = await postUrlEncoded<string>(this.saveAdUrl, data);
			if (!this.isDraft) {
				window.location.reload();
			}
			else {
				prompt(response.data);
			}
		}
		finally {
			this.loading = false;
		}
	}
}
